import {
  IPublicDesktopV1FiltersGetMetaRequest,
  IPublicDesktopV1FiltersGetMetaResponse,
  IPublicDesktopV1FiltersGetMetaResponse200,
  IPublicDesktopV1FiltersGetMetaResponse400,
  createPublicDesktopV1FiltersGetMetaModel,
  fetchPublicDesktopV1FiltersGetMeta,
} from 'shared/repositories/commercial-search-offers/desktop/v1/filters/get-meta';
import { FetchAssertsService } from 'shared/services/FetchAssertsService';
import { IApplicationContext } from 'shared/types/applicationContext';

export async function fetchPublicDesktopV1FiltersGetCountService(
  dependencies: IApplicationContext,
  parameters: IPublicDesktopV1FiltersGetMetaRequest,
): Promise<IPublicDesktopV1FiltersGetMetaResponse> {
  const { httpApi, logger } = dependencies;

  const fetchAssertsService = new FetchAssertsService(
    createPublicDesktopV1FiltersGetMetaModel(parameters),
    'src/shared/store/serverSide/commercial-search-offers/desktop/v1/filters/get-count/internal/fetchService.ts',
    logger,
  );

  return fetchPublicDesktopV1FiltersGetMeta<
    IPublicDesktopV1FiltersGetMetaResponse200,
    IPublicDesktopV1FiltersGetMetaResponse400
  >({
    httpApi,
    parameters,
  }).then(
    result => {
      const statusCode = result.statusCode;

      switch (result.statusCode) {
        case 200:
          return result.response;
        case 400:
          throw fetchAssertsService.assert400StatusCodeError(result);
        default:
          throw fetchAssertsService.assertUnknownStatusCodeError(statusCode);
      }
    },
    error => {
      throw fetchAssertsService.assertUnknownServerError(error);
    },
  );
}
